module.exports = __webpack_public_path__ + "img/lsuoreg.95171130.png";